import { h, render } from 'preact';
import ProductContext from './product-context';
import Product from './product';

export default (element, data) => {
  const init = () => {
    const storeLocatorData = document.getElementById('store-locator-data');
    render(
      <ProductContext data={data}>
        <Product
          storeLocatorData={
            storeLocatorData ? JSON.parse(storeLocatorData.textContent) : {}
          }
        />
      </ProductContext>,
      element,
    );
  };

  init();
};
